import * as React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

export default function CallToAction() {
  return (
    <Box
      sx={{
        width: "90%",
        height: "fit-content",
        textAlign: "center",
        margin: "auto",
        marginBottom: { xs: "2rem", md: "10rem" },
        backgroundColor: 'primary.dark',
        // background:
        //   "linear-gradient(135deg, #f4f9ff30 0%, rgba(255, 255, 255, 0) 70%), linear-gradient(45deg, #ffffff 0%, #f4f9ff30 100%)",
        // backdropFilter: "blur(20px)",
        background: "linear-gradient(0deg, rgba(244, 249, 255, 0) 0%, #F4F9FF 100%)",
        borderRadius: "20px",
        boxShadow: "0 8px 32px 0 rgb(59 72 255 / 11%)",
      }}
    >
      <Box
        sx={{
          height: "inherit",
          width: "inherit",
          textAlign: "center",
          margin: "auto",
          // backgroundColor: "#cbe4de33",
          color: "black",
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <Typography variant="h4" fontWeight={700} gutterBottom>
          <span style={{ color: "#074DC0" }}>APIK CHECKOUT – </span>WORLD’S MOST
          ADVANCED, FEATURE RICH SINGLE CLICK CHECKOUT FOR D2C STORES
        </Typography>
        <Typography
          variant="h6"
          sx={{ width: { xs: "80vw", md: "80%" }, margin: "auto" }}
          gutterBottom
        >
          Drive higher conversion using Upsells, Flexible discounting, RTO
          Reduction engine and repeat Purchases.
        </Typography>
      </Box>
    </Box>
  );
}
